import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const COLS = [
  {
    title: "SHOP",
    links: [
      { label: "The Arsenal", section: "collections" },
      { label: "Founder's Edition", section: "founder" },
    ],
  },
  {
    title: "BRAND",
    links: [
      { label: "The Code", section: "manifesto" },
      { label: "Join The Pack", section: "founder" },
    ],
  },
  {
    title: "SUPPORT",
    links: [
      { label: "Contact", href: "mailto:hello@lonewolfgymgear.com" },
      { label: "Returns & Refunds", to: "/returns" },
    ],
  },
];

export const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const go = (section) => {
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: section } });
      return;
    }
    const el = document.getElementById(section);
    if (el) {
      if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
      else el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
  <footer id="footer" data-testid="footer" className="relative bg-[#050505] border-t border-white/10 overflow-hidden">
    {/* Giant brand wordmark */}
    <div className="relative mx-auto max-w-[1600px] px-6 md:px-10 pt-24 pb-10">
      <div className="grid grid-cols-12 gap-10">
        <div className="col-span-12 lg:col-span-4">
          <div className="flex items-center gap-3">
            <img src="/generated/wolf_white.png" alt="Lone Wolf" className="w-10 h-10 object-contain" />
            <span className="flex flex-col leading-none">
              <span className="font-display font-extrabold tracking-[0.18em] text-lg text-white">LONE WOLF</span>
              <span className="font-sans tracking-[0.42em] text-[9px] text-white/50">GYM GEAR</span>
            </span>
          </div>
          <p className="mt-6 font-sans text-sm text-white/45 max-w-xs leading-relaxed">
            The original pioneers of bodybuilding. You and the steel. Nothing else.
          </p>
        </div>

        {COLS.map((c) => (
          <div key={c.title} className="col-span-6 sm:col-span-4 lg:col-span-2">
            <h4 className="font-sans text-[11px] tracking-[0.3em] text-white/40 mb-5">{c.title}</h4>
            <ul className="space-y-3">
              {c.links.map((l) => (
                <li key={l.label}>
                  {l.href ? (
                    <a href={l.href} className="font-sans text-sm text-white/65 hover:text-white transition-colors duration-300">
                      {l.label}
                    </a>
                  ) : l.to ? (
                    <button
                      onClick={() => navigate(l.to)}
                      className="font-sans text-sm text-white/65 hover:text-white transition-colors duration-300 text-left"
                    >
                      {l.label}
                    </button>
                  ) : (
                    <button
                      onClick={() => go(l.section)}
                      className="font-sans text-sm text-white/65 hover:text-white transition-colors duration-300 text-left"
                    >
                      {l.label}
                    </button>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>

    <div className="relative w-full overflow-hidden border-t border-white/10">
      <h2 className="font-display font-black uppercase tracking-normal text-center leading-none text-white/[0.05] text-[22vw] select-none pointer-events-none py-4">
        LONE WOLF
      </h2>
    </div>

    <div className="relative mx-auto max-w-[1600px] px-6 md:px-10 py-8 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-white/10">
      <p className="font-sans text-[11px] tracking-[0.25em] text-white/35">NO FOLLOWERS.</p>
      <img src="/generated/wolf_white.png" alt="" aria-hidden="true" className="w-7 h-7 object-contain opacity-60" />
      <p className="font-sans text-[11px] tracking-[0.25em] text-white/35">NO COMPROMISES.</p>
    </div>
    <p className="text-center font-sans text-[10px] tracking-[0.2em] text-white/25 pb-8">
      © 2026 LONE WOLF GYM GEAR — BUILT FOR THE FEW
    </p>
  </footer>
  );
};

export default Footer;
